<script setup>
import { computed } from 'vue';

const props = defineProps({
  memory: {
    type: Object,
    default: () => ({}),
  },
});

const facts = computed(() =>
  (props.memory?.facts || []).map(item => item?.value || item).filter(Boolean)
);
const products = computed(() =>
  (props.memory?.selected_products || [])
    .map(item => item?.name || item)
    .filter(Boolean)
);
</script>

<template>
  <div class="px-4 py-3 text-sm text-n-slate-12 space-y-3">
    <p v-if="memory.active_topic" class="font-medium">
      {{ memory.active_topic }}
    </p>
    <p v-if="memory.summary" class="leading-5 text-n-slate-11">
      {{ memory.summary }}
    </p>
    <div v-if="memory.pending_action" class="rounded-lg bg-n-brand/5 px-3 py-2">
      <p class="text-xs font-medium text-n-slate-11">
        {{ $t('CONVERSATION_SIDEBAR.LUMERAI_MEMORY.NEXT_STEP') }}
      </p>
      <p class="mt-1 leading-5">{{ memory.pending_action }}</p>
    </div>
    <div v-if="facts.length">
      <p class="text-xs font-medium text-n-slate-11 mb-1">
        {{ $t('CONVERSATION_SIDEBAR.LUMERAI_MEMORY.CONFIRMED_FACTS') }}
      </p>
      <ul class="list-disc pl-4 space-y-1">
        <li v-for="fact in facts" :key="fact">{{ fact }}</li>
      </ul>
    </div>
    <div v-if="products.length">
      <p class="text-xs font-medium text-n-slate-11 mb-1">
        {{ $t('CONVERSATION_SIDEBAR.LUMERAI_MEMORY.SELECTED_ITEMS') }}
      </p>
      <ul class="list-disc pl-4 space-y-1">
        <li v-for="product in products" :key="product">{{ product }}</li>
      </ul>
    </div>
  </div>
</template>
